import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  AdvertisingCampaignInterface,
  LastAvailabilityUpdates,
  LocationWithAvailabilities,
} from "src/app/shared/models/advertising-campaigns/advertising-campaign.interface";
import {
  LocationAvailabilityDto,
  TotalPrice,
} from "src/app/shared/models/calcul/totalPrice";
import { DateFilter } from "src/app/shared/models/date-filte.interface";
import { BadgeService } from "src/app/shared/services/badge.service";

@Component({
  selector: "app-list-location-partner-availabilities",
  templateUrl: "./list-location-partner-availabilities.component.html",
})
export class ListLocationPartnerAvailabilitiesComponent implements OnInit {
  @Input() totalPrice: TotalPrice[];
  @Input() startDate: Date;
  @Input() endDate: Date;
  @Input() advertisingCampaign: AdvertisingCampaignInterface;
  selectedPeriod: LocationWithAvailabilities[] = [];
  @Input() locationsWithAvailabilities: LocationWithAvailabilities;
  @Output() emitLocationAvailabilityDto =
    new EventEmitter<LastAvailabilityUpdates>();
  @Output() cancelAction: EventEmitter<boolean> = new EventEmitter();
  constructor(public badgeService: BadgeService) {}

  ngOnInit(): void {}

  close() {
    this.cancelAction.emit(true);
  }

  saveAvailability(
    event: any,
    period: DateFilter,
    locationAvailabilityDto: LocationAvailabilityDto
  ) {
    const index = this.selectedPeriod.findIndex(
      (sp) => sp.companyName === locationAvailabilityDto.companyName
    );

    if (event.target.checked) {
      if (index > -1) {
        const alreadyExists = this.selectedPeriod[
          index
        ].listOfAvailableDates.some(
          (p) =>
            p.startDate === period.startDate && p.endDate === period.endDate
        );
        if (!alreadyExists) {
          this.selectedPeriod[index].listOfAvailableDates.push(period);
        }
      } else {
        this.selectedPeriod.push({
          companyName: locationAvailabilityDto.companyName,
          listOfAvailableDates: [period],
        });
      }
    } else {
      if (index > -1) {
        this.selectedPeriod[index].listOfAvailableDates = this.selectedPeriod[
          index
        ].listOfAvailableDates.filter(
          (p) =>
            p.startDate !== period.startDate || p.endDate !== period.endDate
        );
        if (this.selectedPeriod[index].listOfAvailableDates.length === 0) {
          this.selectedPeriod.splice(index, 1);
        }
      }
    }
  }
  isPeriodChecked(companyName: string, availability: DateFilter): boolean {
    return this.selectedPeriod.some(
      (sp) =>
        sp.companyName === companyName &&
        sp.listOfAvailableDates.some(
          (p) =>
            p.startDate &&
            p.endDate &&
            availability.startDate &&
            availability.endDate &&
            new Date(p.startDate).getTime() ===
              new Date(availability.startDate).getTime() &&
            new Date(p.endDate).getTime() ===
              new Date(availability.endDate).getTime()
        )
    );
  }

  saveChanges() {
    const lastAvailabilityUpdates: LastAvailabilityUpdates = {
      lastEndDateChosen: this.endDate,
      lastStartDateChosen: this.startDate,
      locationWithAvailability: this.selectedPeriod,
    };
    this.emitLocationAvailabilityDto.emit(lastAvailabilityUpdates);
  }
}
